var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_tenant",
    "data-name": "icona tenant",
    transform: "translate(-1360.36 -551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_937",
    "data-name": "Tracciato 937",
    d: "M186.487,148.026h-2.756a.591.591,0,0,1-.574-.606v-2.187a.591.591,0,0,1,.574-.606h2.756a.591.591,0,0,1,.574.606v2.187A.591.591,0,0,1,186.487,148.026Zm-2.182-1.213h1.608v-.974h-1.608Z",
    transform: "translate(1186.702 416.33)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_938",
    "data-name": "Tracciato 938",
    d: "M110.5,148.026H107.74a.591.591,0,0,1-.574-.606v-2.187a.591.591,0,0,1,.574-.606H110.5a.591.591,0,0,1,.574.606v2.187A.591.591,0,0,1,110.5,148.026Zm-2.182-1.213h1.608v-.974h-1.608Z",
    transform: "translate(1257.084 416.33)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_939",
    "data-name": "Tracciato 939",
    d: "M70.179,21.752a.547.547,0,0,0-.56-.015L69.3,17.43a.588.588,0,0,0-.572-.559h-1.77a.588.588,0,0,0-.572.559l-.4,5.442v-.6a.614.614,0,0,0-.28-.521.548.548,0,0,0-.567-.013L61.5,23.811V22.272a.614.614,0,0,0-.28-.521.548.548,0,0,0-.567-.013L56.18,24.3a.612.612,0,0,0-.3.533v6.83h-.845a.607.607,0,0,0,0,1.213H69.542a.607.607,0,0,0,0-1.213H57.027V25.19l3.329-1.9v1.539a.614.614,0,0,0,.28.521.548.548,0,0,0,.567.013l3.63-2.073v1.539a.614.614,0,0,0,.28.521.548.548,0,0,0,.567.013l3.63-2.073v7.663a.575.575,0,1,0,1.148,0V22.273A.615.615,0,0,0,70.179,21.752Zm-2.848-1.546h1.022l.16,2.161-1.4.8Zm.865-2.122.067.909h-.843l.067-.909Z",
    transform: "translate(1305.9 534.129)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.411c3d79cbfc88a8b0ca5ea4262fd94a.svg";
export { ForwardRef as ReactComponent };